import axios from "axios";
import { message } from './tool'
import { getToken } from '@/utils/auth';
import store from '@/store';
import md5 from 'md5'
import router from '../router'
import {
  sortByKey
} from '@/utils/index.js'

// create an axios instance
const requestLogin = axios.create({
    baseURL: process.env.VUE_APP_HOSTS_USER, //接口访问地址
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000 // request timeout
  })

  requestLogin.interceptors.request.use(
    config => {
        if (store.state.user.token) {
            config.headers['Authorization'] = getToken();
        }

        // hash验证
        const time = parseInt(Date.now() / 1000)
        var apptypes = localStorage.getItem('apptypes')
        if (config.params && config.params.app_type) {
          apptypes = config.params.app_type
        }
        if (!apptypes) {
          apptypes = 'beikaotong'
        }
        config.params = Object.assign({}, config.params, {
          app_type: apptypes,
          timestrap: time,
          platform: 'pc',
          deviceid: 1,
          channel: 'default',
          version: 'v1.0.0'
        })

        const keys = Object.keys(config.params)
        const keysArray = []
        keys.forEach(item => {
          if (config.params[item] !== undefined) {
            const value = config.params[item].toString().trim()
            // if (config.params[item] instanceof Object) {
            //   value = JSON.stringify(config.params[item])
            // }
            keysArray.push({
              label: item,
              value: value
            })
          }
        })
        const sortKeysArray = sortByKey(keysArray, 'label')
        var hashStrs = ''
        sortKeysArray.forEach(item => {
          hashStrs += item.label + item.value
        })

        const hashKey = process.env.NODE_ENV === 'production' ? 'BF2CAEC459F801E99B8F4C5FE93952B3' : '1234567890'
        // const hashKey = 'BF2CAEC459F801E99B8F4C5FE93952B3'

        const hash = md5(hashStrs + hashKey)
        // console.log(config.params, keysArray, sortKeysArray, hashStrs + hashKey, hash)

        config.params.sign = hash
        return config
    },err => {
        return err
    }
)

requestLogin.interceptors.response.use(config => {
  //  'config.data--',config.data);
  if(config.data.code == 401){
    setTimeout(()=>{
      message.error('未授权，请重新登录')
      store.dispatch('user/logout');
      router.push('/login');
    },1000)
  }
    return config.data
  }, err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          message.error('错误请求')
          break
        case 401:
          message.error('未授权，请重新登录')
          store.dispatch('user/logout');
          router.push('/login');
          break
        case 403:
          message.error('拒绝访问')
          break
        case 404:
          message.error('请求错误，未找到该资源')
          break
        case 408:
          message.error('请求超时')
          break
        case 500:
          message.error('服务器端出错')
          break
        case 501:
          message.error('网络未实现')
          break
        case 502:
          message.error('网络错误')
          break
        case 503:
          message.error('服务不可用')
          break
        case 504:
          message.error('网络超时')
          break
        case 505:
          message.error('http版本不支持该请求')
          break
        default:
          message.error(`连接错误${err.response.status}`)
      }
    } else {
      message.error('连接到服务器失败')
    }
    return err
  })

  export default requestLogin
